import { RequireOnly } from '@pelicargo/types';
import { NARROW_BODY_THRESHOLDS, WIDE_BODY_THRESHOLDS } from '@pelicargo/utils';
import { AircraftType, Cargo } from '@prisma/client';

const getThresholds = (aircraftType: AircraftType) => {
  switch (aircraftType) {
    case AircraftType.NarrowBody:
      return {
        length: NARROW_BODY_THRESHOLDS.length,
        width: NARROW_BODY_THRESHOLDS.width,
        height: NARROW_BODY_THRESHOLDS.height,
        weight: NARROW_BODY_THRESHOLDS.weight,
      };
    case AircraftType.WideBody:
      return {
        length: WIDE_BODY_THRESHOLDS.length,
        width: WIDE_BODY_THRESHOLDS.width,
        height: WIDE_BODY_THRESHOLDS.height,
        weight: WIDE_BODY_THRESHOLDS.weight,
      };
    default:
      return {
        length: Infinity,
        width: Infinity,
        height: Infinity,
        weight: Infinity,
      };
  }
};

export const isOversizedForAircraftType = (
  cargo: RequireOnly<Cargo, 'length' | 'width' | 'height' | 'weight'>,
  aircraftType: AircraftType,
) => {
  const thresholds = getThresholds(aircraftType);

  const overLength = cargo.length > thresholds.length;
  const overWidth = cargo.width > thresholds.width;
  const overHeight = cargo.height > thresholds.height;
  const overWeight = cargo.weight && cargo.weight > thresholds.weight;

  return overLength || overWidth || overHeight || overWeight;
};
